import {
    GETMULTIPLESELECTFORPARTNER_SUCCESS,
    GETMULTIPLESELECTFORPARTNER_FAILED,
    RESET_GETMULTIPLESELECTFORPARTNER,
    LOADING_GETMULTIPLESELECTFORPARTNER,
    NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetGETMULTIPLESELECTFORPARTNER = () => {
    return { type: RESET_GETMULTIPLESELECTFORPARTNER };
};

const partnerGetMultipleSelectListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMULTIPLESELECTFORPARTNER });
    await partnerServices
        .post("getMultipleSelect", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerGetMultipleSelectListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetMultipleSelectListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER,
                payload: err
            });
        });
};

function partnerGetMultipleSelectListsuccess(data) {
    return {
        type: GETMULTIPLESELECTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerGetMultipleSelectListFailed(data) {
    return {
        type: GETMULTIPLESELECTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetGETMULTIPLESELECTFORPARTNER, partnerGetMultipleSelectListReq }